<template>
  <v-dialog v-model="active" persistent :max-width="maxWidth">
    <v-card class="rounded-xl elevation-16">
      <v-toolbar dense dark color="blueKonect" elevation="0">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="toolButton">
          <v-btn v-if="!actionBtn" small text color="white" @click="remove()">
            {{ btnMsgRemove }}
            <v-icon right>
              {{ iconMsgRemove }}
            </v-icon>
          </v-btn>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-toolbar>
      <v-card-text
        class="scrollStyle"
        style="max-height: 300px; overflow: scroll; overflow-x: hidden;"
      >
        <slot name="header"></slot>

        <p class="mt-5 text-h6">{{ removeMsg }}</p>
        <slot></slot>
      </v-card-text>
      <v-card-actions v-if="!toolButton">
        <v-spacer></v-spacer>
        <v-btn small text color="blue-grey" @click="cancel()">
          Cancelar
        </v-btn>
        <v-btn v-if="!actionBtn" small text :color="btnColor" @click="remove()">
          {{ btnMsgRemove }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const props = {
  title: {
    default: "Aviso importante",
    type: String,
  },
  removeMsg: {
    default: "¿Está seguro que desea eliminar el registro?",
    type: String,
  },
  btnMsgRemove: {
    default: "Eliminar",
    type: String,
  },
  iconMsgRemove: {
    default: "mdi-upload",
    type: String,
  },
  btnColor: {
    default: "error",
    type: String,
  },
  active: {
    default: false,
    type: Boolean,
  },
  toolButton: {
    default: false,
    type: Boolean,
  },
  loading: {
    default: false,
    type: Boolean,
  },
  clickRemove: Function,
  clickCancel: Function,
  actionBtn: {
    default: false,
    type: Boolean,
  },
  maxWidth: {
    default: 400,
    type: Number,
  },
};

export default {
  data: () => ({}),
  methods: {
    cancel() {
      this.clickCancel();
    },
    remove() {
      this.clickRemove();
    },
  },
  props: props,
};
</script>

<style scoped>
.scrollStyle {
  scrollbar-color: yellow #4cacb9 !important;
  scrollbar-base-color: orange;
}
::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 500px 10px 10px #4cacb934;
}
</style>
